import {NgModule} from '@angular/core';
import {AgGridModule} from 'ag-grid-angular';
import {ShipmentInfoDetailsComponent} from './shipment-info-details.component';
import {RadioaktivCellComponent} from './radioaktiv-cell/radioaktiv-cell.component';
import {KorrekturModule} from '../sendungskorrektur/korrektur/korrektur.module';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {CommonModule} from '@angular/common';
import { InfoCellComponent } from './info-cell/info-cell.component';

// All Modules
import { ColliEventsModule } from '../colli-events/colli-events.module';
import { DangerousGoodsModule } from '../dangerous-goods/dangerous-goods.module';
import { DispoDetailsModule } from '../dispo-details/dispo-details.module';
import { SendungsereignisseModule } from '../sendungsereignisse/sendungsereignisse.module';
import { SendungsketteModule } from '../sendungskorrektur/sendungskette/sendungskette.module';

import { TabsModule } from 'ngx-bootstrap/tabs';
import { ColliUbersichtModule } from '../colli-ubersicht/colli-ubersicht.module';

@NgModule({
  declarations: [ShipmentInfoDetailsComponent, RadioaktivCellComponent, InfoCellComponent],
    imports: [
        KorrekturModule,
        CollapseModule,
        AgGridModule,
        FontAwesomeModule,
        CommonModule,
        ColliEventsModule,
        DangerousGoodsModule,
        DispoDetailsModule,
        SendungsereignisseModule,
        SendungsketteModule,
        ColliUbersichtModule,
        TabsModule

    ],
  entryComponents: [RadioaktivCellComponent, InfoCellComponent],
  exports: [ShipmentInfoDetailsComponent],

})
export class ShipmentInfoDetailsModule {
}
